import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class BarcodeRecognitionParams {
    barcodeParams: OrdinaryObject<number>;
    advancedParams: OrdinaryObject<number>;
    scanDpi: number[];
    qsbcIni: string[];
    extensiveScan = false;
}
